import type { UserItem, UserListResponse } from '@/api/modules/video_comments'
import api from '@/api/modules/video_comments'
import { defineStore } from 'pinia'
import { ref } from 'vue'

const useDataStore = defineStore(
  'data',
  () => {
    const userList = ref<UserItem[]>([])

    async function getUserList() {
      const res = await api.get_user_list() as unknown as UserListResponse
      // 根据 api/index.ts 的拦截器，res 实际上是 response.data
      // 其格式为 { code: 200, data: UserItem[], msg: string }
      userList.value = res.data || []
      return userList.value
    }

    return {
      userList,
      getUserList,
    }
  },
)

export default useDataStore
